'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const universal_color = require('../../style/universal.color.js');
const index = require('../../node_modules/color/index.js');
const colors_map = require('../../style/colors.map.js');

var mlbWhite = universal_color.mlbWhite,
  mlbGrey7 = universal_color.mlbGrey7,
  linkBlue = universal_color.linkBlue,
  transparent = universal_color.transparent;

// Return the styles needed for a provided team color
var retrieveTeamColorMap = function retrieveTeamColorMap() {
  var teamColor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : linkBlue;
  var hollowMode = arguments.length > 1 ? arguments[1] : undefined;
  var themeType = arguments.length > 2 ? arguments[2] : undefined;
  var hollow = hollowMode === 'hollow';
  var colorMap = {
    color: hollow ? teamColor : mlbWhite,
    backgroundColor: hollow ? transparent : teamColor,
    borderColor: hollow ? teamColor : '',
    hoverColor: hollow ? mlbWhite : '',
    hoverBackgroundColor: hollow ? themeType === 'dark' ? mlbGrey7 : teamColor : index.default(teamColor).mix(index.default('black'), 0.2).hex()
  };
  return colorMap;
};

// A map of all the colors the various button configurations require
var ButtonColors = {
  light: {
    hollow: colors_map.ComponentColorsHollowLight,
    solid: colors_map.ComponentColorsSolidLight
  },
  dark: {
    hollow: colors_map.ComponentColorsHollowDark,
    solid: colors_map.ComponentColorsSolidDark
  }
};

exports.ButtonColors = ButtonColors;
exports.retrieveTeamColorMap = retrieveTeamColorMap;
